import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Login/login.css";
import Swal from "sweetalert2";
import imagephone from "../../images/High res mobile.png";

const Loginpage = () => {
  const [email, setEmail] = useState(""); // State for email
  const [password, setPassword] = useState(""); // State for password
  const navigate = useNavigate(); // Initialize useNavigate
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // ✅ Loading state
  const [femail, setFEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!femail) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: femail,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setFEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const showAutoCloseAlert = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const showAutoError = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    if (password.length === 0) {
      setPasswordError("Password cannot be empty.");
      return; // Stop form submission
    }

    if (password.length > 12) {
      setPasswordError("Password should not exceed 12 characters.");
      return; // Stop form submission
    }

    // Clear error message if validation passes
    setPasswordError("");
    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://toptennis.io/api/user/login",
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.token) {
        // Save the token to localStorage with the key 'user_token'
        localStorage.setItem("user_token", response.data.token);
        showAutoCloseAlert("Login Successful", response.data);
        // If login is successful, navigate to the home page

        navigate("/Home");
        window.location.reload();
      } else {
        // Handle error responses
        showAutoError("Login failed", response.data);
      }
    } catch (error) {
      if (!navigator.onLine) {
        showAutoError("No internet connection.");
      } else if (error.response?.status === 404) {
        showAutoError(
          "Email/password not recognised. Please try again or register."
        );
      } else {
        showAutoError("Something went wrong. Please try again later.");
      }
    } finally {
      // catch (error) {
      //   showAutoError("Invalid email/password – please try again or register");
      // }
      setIsLoading(false); // ✅ Stop loading after request completes
    }
  };

  const handleRegister = () => {
    // Navigate to the registration page
    navigate("/register");
  };
  const handleForgotPassword = () => {
    // Navigate to the registration page
    navigate("/forgotpassword");
  };

  return (
    <>
      {/* <div
        className="modal fade show"
        id="formModal"
        tabIndex="-1"
        aria-labelledby="contained-modal-title-vcenter"
        role="dialog"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-bottom"
          role="document"
        >
          <div
            className="modal-content"
            style={{ backgroundColor: "black", marginBottom: "0" }}
          >
            <div className="modal-header">
              <h5
                className="modal-title"
                id="formModalLabel"
                style={{ color: "white" }}
              >
                Login
              </h5>
            </div>
            <div className="modal-body1" style={{ padding: "30px" }}>
              <form onSubmit={handleSubmit}>
                <div className="input-container">
                  <input
                    type="email"
                    required
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <label>Email Address</label>
                </div>
                <div className="input-container">
                  <input
                    type="password"
                    required
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    maxLength={12}

                  />
                  <label>Password</label>
                  {passwordError && (
                    <span style={{ color: "red", fontSize: "12px", paddingLeft: "4%" }}>
                      {passwordError}
                    </span>
                  )}
                </div>
                <button type="submit" className="btn">
                  Continue
                </button>
              </form>


              <div
                className="register-link"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                  padding: "10px"
                }}
              >
                <div>
                  <button
                    onClick={handleForgotPassword}
                    style={{
                      background: "none",
                      color: "lightblue",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Forgot Your Password?
                  </button>
                </div>

                <div>
                  <button
                    onClick={handleRegister}
                    style={{
                      background: "none",
                      color: "lightblue",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Create an account?
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div> */}
      <div className="page-container">
        {/* Hero Section */}
        <div className="hero-section">
          {/* Phone Image */}
          <div className="hero-image">
            <img src={imagephone} alt="App Preview" className="imgphone" />
          </div>

          {/* Text Content */}
          <div className="hero-text">
            <p className="head1">Top Tennis UK</p>
            <p className="head2">
              Start Playing For <span className="free">Free</span> Today!
            </p>
            <p className="head5">a new way to play fantasy sports</p>
          </div>

          {/* Login Box */}
          <div className="login-box">
            <h5 className="modal-title">Login</h5>
            <form onSubmit={handleSubmit}>
              <div className="input-container">
                <label>Email Address</label>
                <input
                  type="email"
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="input-container">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                {passwordError && (
                  <span className="error-text">{passwordError}</span>
                )}
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? <span className="spinner"></span> : "Continue"}
              </button>

              <div className="helper-links">
                <button type="button" onClick={handleForgotPassword}>
                  Forgot Your Password?
                </button>
                <button type="button" onClick={handleRegister}>
                  Create an account?
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Footer Section */}
        <div>
          <div className="card-footernew">
            <div className="footer">
              {/* <div className="border row">
                <div className="border col-12 mb-3">
                  <div className="footer-sub">
                    <h4>Keep in touch</h4>
                    <h5>Join our newsletter. We promise not to spam!</h5>
                    <input
                      type="email"
                      placeholder="Email Address"
                      className="footer-input"
                      value={femail}
                      onChange={(e) => setFEmail(e.target.value)}
                    />
                    <button className="subscribe-btn" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                    {message && <p style={{ marginTop: "10px" }}>{message}</p>}
                  </div>
                </div>
                <div className="border col-6">
                  <div className="footer-sub1">
                    <h4>Quick links</h4>
                    <a href="/news" className="footer-link">
                      News
                    </a>
                    <a href="/faq" className="footer-link">
                      FAQs
                    </a>
                  </div>
                </div>
                <div className="border col-6">
                  <div className="footer-sub1 secondicon">
                    <h4>Socials</h4>
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/toptennisio/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-circle"
                        style={{ textDecoration: "none" }}
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/toptennisuk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-circle"
                        style={{ textDecoration: "none" }}
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div>
                    <div className="fl1">
                    <a
                      href="/terms"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&Cs
                    </a>
                    <a
                      href="/privacy"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                      <span className="footer-link">
                        Email: contact@toptennis.io
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="footer-firstline">
                <div className="footer-sub">
                  <h4>Keep in touch</h4>
                  <h5>Join our newsletter. We promise not to spam!</h5>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="footer-input"
                    value={femail}
                    onChange={(e) => setFEmail(e.target.value)}
                  />
                  <button className="subscribe-btn" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                  {message && <p style={{ marginTop: "10px" }}>{message}</p>}
                </div>

                <div className="footer-sub1">
                  <h4>Quick links</h4>
                  <a href="/news" className="footer-link">
                    News
                  </a>
                  <a href="/faq" className="footer-link">
                    FAQs
                  </a>
                </div>

                <div className="footer-sub1 secondicon">
                  <h4>Socials</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/toptennisio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/toptennisuk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                  <div className="fl1">
                  <a
                    href="/terms"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    T&Cs
                  </a>
                  <a
                    href="/privacy"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loginpage;
